import "cross-fetch/polyfill";
import { fetchRetryTimeout } from "../utils/fetchRetryTimeout";

/**
 * Get site configuration from appsettings.json
 * @returns {Promise<{matomoContainerName: string}>} Site configuration properties
 */
export const getSiteConfig = async () => {
  const response = await fetchRetryTimeout(
    `/appsettings.json`, // Absolute path from root
    {
      retryOn: [500, 503],
      retries: 1,
    },
    10000,
  );
  if (response.status === 200) {
    const contentType = response.headers.get("content-type");

    if (!contentType?.includes("application/json")) {
      throw new Error(
        `Invalid content type. Expected JSON but got ${contentType}. This usually means the file was not found or is not accessible.`,
      );
    }

    const config = await response.json();
    return config;
  } else if (response.status === 404) {
    throw new Error(
      `Configuration file not found (404). The file /appsettings.json does not exist on the server. Please ensure the file is deployed to the root directory (wwwroot) of the web application.`,
    );
  } else {
    // In unhandled error, throw response body as text
    const errorText = await response.text();
    throw new Error(
      `Failed to load configuration (HTTP ${response.status}): ${errorText.substring(0, 200)}`,
    );
  }
};
